import { FetchAPI } from 'utils/fetch/fetch-api';
import { Glossary } from 'utils/types/glossaries';

class GlossariesService extends FetchAPI {
	getGlossary = (): Promise<Glossary> => this.get<Glossary>();
}

export { GlossariesService };
